/* 🤖 this file was generated by svg-to-ts */
export const mgcIconReportFormsFilled: {
  name: 'report-forms-filled';
  data: string;
} = {
  name: 'report-forms-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.58 4.047c-.733.14-1.4.821-1.537 1.57C3.019 5.75 3 6.33 3 6.927V8h5V4l-1.61.004c-.885.003-1.7.022-1.81.043M10 6v2h11V6.927c0-.597-.019-1.177-.043-1.31-.141-.768-.806-1.433-1.574-1.574-.162-.029-1.699-.043-4.81-.043H10zm-7 6.5V15h5v-5H3zm7 0V15h11v-5H10zm-7 5.573c0 .597.019 1.177.043 1.31.141.768.806 1.433 1.574 1.574.145.026.854.043 1.81.043H8v-4H3zM10 19v2h4.573c3.111 0 4.648-.014 4.81-.043.768-.141 1.433-.806 1.574-1.574.024-.133.043-.713.043-1.31V17H10z"/></svg>`
};
